<img src="/images/svelte.png" width="27" alt="Svelte icon" />
